import { Button, Col, ErrorSummary, HorizontalRule, Row } from '@snsw/react-component-library';
import React, { createRef, Fragment, useEffect, useRef, useState } from 'react';
import styles from './DrawingsAndTechDetails.module.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { storeTechStandards } from 'plantDesign/redux/plantDesignDrawingAndTechSlice';
import { TechStandardDetails } from './components/TechStandardDetails';
import { PagePath } from 'shared/constants/pagePath';

export const AddTechStandard = (props) => {
  const techStandardRef = useRef([]);
  const combineErrors = useRef({});

  const dispatch = useDispatch();

  const location = useLocation();
  const navigate = useNavigate();

  const [techStandards, setTechStandards] = useState(location.state?.techStandards || []);
  const [showErrors, setShowErrors] = useState(false);
  const [errorSummary, setErrorSummary] = useState([]);
  const [updatingTechStandardList, setUpdatingTechStandardList] = useState(false);

  const addAnotherTechStandard = () => {
    //max techstandard is 5

    if (techStandards.length >= 5) return;

    let items = [...techStandards];
    items.push({});

    setTechStandards(items);
  };

  const removeTechStandard = (index) => {
    if (techStandards.length <= 1) return;

    setUpdatingTechStandardList(true);

    const items = techStandards.filter((e, i) => i !== index);
    setTechStandards(items);

    combineErrors.current = {}; //reset combine error
    techStandardRef.current.splice(index, 1);

    //this is to trigger re-render of the drawing list
    setTimeout(() => {
      setUpdatingTechStandardList(false);
    }, 0);
  };

  const onTechStandardChange = (details, index) => {
    let items = techStandards.map((e, i) => {
      if (i === index) {
        return { ...details };
      } else {
        return e;
      }
    });
    setTechStandards(items);
  };

  const addTechStandardRef = (el, index) => {
    const ref = createRef();
    ref.current = el;
    techStandardRef.current[index] = ref;
  };

  const onErrorTechStandard = (errorDetails, index) => {
    combineErrors.current[index] = errorDetails;

    let errorArr = [];
    Object.keys(combineErrors.current).forEach((key) => {
      if (Array.isArray(combineErrors.current[key]) && combineErrors.current[key].length > 0)
        errorArr = errorArr.concat(combineErrors.current[key]);
    });

    setErrorSummary(errorArr);
  };

  const validateAll = () => {
    const result = [];
    techStandardRef.current.forEach((ref) => {
      if (ref.current) {
        result.push(ref.current.validate());
      }
    });

    return result.reduce((p, c) => {
      return p && c;
    }, true);
  };

  const onSave = () => {
    if (validateAll()) {
      dispatch(storeTechStandards(techStandards));
      navigate(PagePath.plantDesignDrawingAndTechnicalDetails);
    } else {
      setShowErrors(true);
    }
  };

  useEffect(() => {
    //clear state
    window.history.replaceState({}, document.title);
  }, []);

  return (
    <>
      <Row>
        <Col span={8}>
          <ErrorSummary errors={errorSummary} />
          <span className={styles.labelMsg}>
            Add technical standards listed in the Designer and Design verifier statement.
          </span>
          {!updatingTechStandardList && (
            <>
              {techStandards.map((x, index) => (
                <Fragment key={index}>
                  <TechStandardDetails
                    index={index}
                    ref={(el) => {
                      addTechStandardRef(el, index);
                    }}
                    showRemoveButton={techStandards.length >= 2}
                    onRemoveClick={removeTechStandard}
                    details={x}
                    onChange={(details) => {
                      onTechStandardChange(details, index);
                    }}
                    onErrorChange={(error) => {
                      onErrorTechStandard(error, index);
                    }}
                    triggerValidate={showErrors}
                  />
                </Fragment>
              ))}
            </>
          )}
        </Col>
      </Row>

      <Row>
        <Col span={8}>
          {techStandards.length < 5 && (
            <Button className={styles.marginTop2rem} variant="secondary" onClick={addAnotherTechStandard}>
              + Add another technical standard
            </Button>
          )}
        </Col>
      </Row>

      <HorizontalRule />

      <Button variant="primary" onClick={onSave}>
        Save
      </Button>

      <Button
        className={styles.mobileSaveExitMargin}
        variant="secondary"
        onClick={() => {
          navigate.goBack();
        }}
      >
        Cancel
      </Button>
    </>
  );
};
